import ReactDOM from "react-dom/client";
import Marquee from "react-fast-marquee";

const CustomMarquee = ({ useBorderText = true, borderText = "", images = [] }) => {
  return (
    <div>
      {useBorderText && borderText && <BorderMarquee text={borderText} />}

      <Marquee className="" autoFill>
        {images.map(img => (
          <img className="h-[200px] w-auto object-cover focal-lg:h-[334px]" src={img} alt="" />
        ))}
      </Marquee>

      {useBorderText && borderText && <BorderMarquee text={borderText} />}
    </div>
  );
};

const BorderMarquee = ({ text }) => {
  return (
    <Marquee className="flex items-center h-[16px] bg-black text-white focal-lg:h-[28px]" autoFill>
      <span className="block font-bebas uppercase text-[8px] tracking-[12px] mx-8 focal-lg:text-[15px]">{text}</span>
    </Marquee>
  );
};

const container = document.getElementById("marquee-container");
const root = ReactDOM.createRoot(container);

const dataElement = document.querySelector("#js-marquee-data");
const data = JSON.parse(dataElement.innerText);

root.render(<CustomMarquee useBorderText={data.useBorderText} borderText={data.borderText} images={data.images} />);
